<template>
  <v-dialog 
    v-model="visible" 
    max-width="600px"
    @keydown.esc="close"
    role="dialog"
    aria-modal="true"
    aria-labelledby="shortcuts-dialog-title">

    <v-card>
      <v-card-title id="shortcuts-dialog-title" class="text-h5">
        {{ $t('accessibility.keyboardShortcuts') }}
        <v-spacer></v-spacer>
        <v-btn 
          icon 
          @click="close"
          :aria-label="$t('accessibility.closeDialog')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text>
        <v-list two-line>
          <v-list-item v-for="(shortcut, index) in shortcuts" :key="index">
            <v-list-item-content>
              <v-list-item-title>{{ shortcut.description }}</v-list-item-title>
              <v-list-item-subtitle>
                <kbd class="keyboard-key">{{ formatKeys(shortcut.keys) }}</kbd>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-divider class="my-4"></v-divider>

          <v-subheader>{{ $t('accessibility.navigation') }}</v-subheader>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('navigation.nextElement') }}</v-list-item-title>
              <v-list-item-subtitle>
                <kbd class="keyboard-key">Tab</kbd>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('navigation.previousElement') }}</v-list-item-title>
              <v-list-item-subtitle>
                <kbd class="keyboard-key">Shift + Tab</kbd>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('navigation.activateElement') }}</v-list-item-title>
              <v-list-item-subtitle>
                <kbd class="keyboard-key">Enter</kbd> {{ $t('or') }} <kbd class="keyboard-key">Space</kbd>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>

          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>{{ $t('navigation.closeDialog') }}</v-list-item-title>
              <v-list-item-subtitle>
                <kbd class="keyboard-key">Escape</kbd>
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn 
          color="primary" 
          text 
          @click="close">
          {{ $t('close') }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { registry } from '@/utils/keyboardShortcuts';

export default {
  name: 'KeyboardShortcutsHelp',

  props: {
    value: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    },

    shortcuts() {
      return registry.getAllShortcuts();
    }
  },

  watch: {
    visible(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // Focus the close button when dialog opens
          const closeBtn = this.$el.querySelector('[aria-label*="close"]');
          if (closeBtn) {
            closeBtn.focus();
          }
        });
      }
    }
  },

  methods: {
    close() {
      this.visible = false;
    },

    formatKeys(keys) {
      if (!keys) return '';
      return keys
        .split('+')
        .map(k => k.charAt(0).toUpperCase() + k.slice(1))
        .join(' + ');
    }
  }
};
</script>

<style scoped>
.keyboard-key {
  display: inline-block;
  padding: 4px 8px;
  background-color: #f5f5f5;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-family: monospace;
  font-size: 0.875rem;
  font-weight: 600;
  color: #333;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  margin: 0 2px;
}

.v-list-item__subtitle {
  margin-top: 4px;
}
</style>
